module.exports = __webpack_public_path__ + "prod/1.42.2/img/msg2.f3a09da5.png";